export * from './wall-type-8.component'